export const OTHER_DISCIPLINE = 'other';
